export const LOGIN_USER = "dashboard/LOGIN_USER";
export const LOGIN_USER_SUCCESS = "dashboard/LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILURE = "dashboard/LOGIN_USER_FAILURE";
